import React from "react";
import Map from "../Map/index";
import "./styles.css";

export default function MapContainer({
  locations,
  zoomLevel,
  disableHover,
  region,
  center,
}) {
  const fakeLocations = [
    {
      lat: 4.349332756495644,
      lng: 13.81313250637801,
    },
    {
      lat: 6.357659551997928,
      lng: 18.869820043232085,
    },
    {
      lat: 7.681824258826598,
      lng: 13.362258650015006,
    },
    {
      lat: 2.164845068345556,
      lng: 21.025880912601508,
    },
    {
      lat: 6.056143701401141,
      lng: 24.445027174627395,
    },
  ];

  return (
    <div className="map-container">
      <Map
        locations={locations ? locations : fakeLocations}
        zoomLevel={zoomLevel}
        disableHover={disableHover}
        region={region}
        center={center}
      ></Map>
    </div>
  );
}
